










// @ts-ignore
import SelfCareHeading from "./selfcare-heading.ts";
export default SelfCareHeading;
